<div class="toast-content-container" [ngClass]="data.iconType">

  <div class="icon-container">
    <mat-icon *ngIf="data.iconType === 'error'" class="alert-icon">close</mat-icon>
    <mat-icon *ngIf="data.iconType === 'success'" class="alert-icon">check</mat-icon>
    <mat-icon *ngIf="data.iconType === 'warning'" class="alert-icon">warning</mat-icon>
    <mat-icon *ngIf="data.iconType === 'info'" class="alert-icon">info</mat-icon>
  </div>

  <div class="text-container">
    <h3 class="dialog-title">{{ data.title | translate }}</h3>
    <div class="dialog-message">
      {{ data.message | translate }}
    </div>
  </div>

  <button mat-icon-button (click)="onClose()" class="toast-close-button">
      <mat-icon>close</mat-icon>
  </button>
</div>
